/** Bound auth/REST requests so a suspended connection cannot hold the auth
 * lock (and every following sync attempt) indefinitely. Caller abort wins. */
export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit,
  timeoutMs = 30_000,
): Promise<Response> {
  const controller = new AbortController();
  const source = init.signal ?? (input instanceof Request ? input.signal : undefined);
  const abort = (): void => controller.abort(source?.reason);
  if (source?.aborted) abort();
  else source?.addEventListener('abort', abort, { once: true });
  const timer = setTimeout(() => controller.abort(new DOMException('Richiesta scaduta. Riprova la sincronizzazione.', 'TimeoutError')), timeoutMs);
  try {
    return await fetch(input, { ...init, signal: controller.signal });
  } finally {
    clearTimeout(timer);
    source?.removeEventListener('abort', abort);
  }
}
